// extracted by mini-css-extract-plugin
export default {"charternotelabel":"CharterNotes_charternotelabel__ZokTA","charternotecontent":"CharterNotes_charternotecontent__uFWxD"};